<template>
    <div class="social-share-app" v-click-outside="outside" >
        <div class="social" :id="'social-' + id" >
            <ShareNetwork
                network="telegram" :title="title"
                :url="url" hashtags="storeglide">
                <img src="/img/share_telegram.svg">
            </ShareNetwork>
            <ShareNetwork
                network="facebook" :title="title"
                :url="url" hashtags="storeglide">
                <img src="/img/share_fb.svg">
            </ShareNetwork>
            <ShareNetwork
                network="linkedIn" :title="title"
                :url="url" hashtags="storeglide">
                <img src="/img/share_linkdin.svg">
            </ShareNetwork>
            <ShareNetwork
                network="twitter" :title="title"
                :url="url" hashtags="storeglide">
                <img src="/img/share_twitter.svg">
            </ShareNetwork>
            <a href="#" @click.stop.prevent="copyUrl">
                <img src="/img/share_link.svg"></a>

        </div>
        <img src="/img/share_more.svg" class="share-more" @click="toogle" :id="'share-' + id">

    </div>

</template>

<script>

export default {

    props: ['id', 'url', 'title'],
    data() {
        return {
            clickOutside: 0,
            clickInside: 0,
        };
    },

    methods: {
        outside: function (e) {
            $('#social-' + this.id).hide();
            $('#share-' + this.id).removeClass('active');
        },
        inside: function(e) {
            this.clickInside += 1
        },

        toogle() {
            var isActive = $('#share-' + this.id).hasClass('active');
            if (isActive) {
                $('#social-' + this.id).hide();
                $('#share-' + this.id).removeClass('active');
            } else {
                this.hideAll();
                $('#social-' + this.id).show();
                $('#share-' + this.id).addClass('active');
            }

        },
        hideAll() {
            $('.social-share-app .social').hide();
            $('.social-share-app .share-more').removeClass('active');
        },
        copyUrl() {
            let container = this.$refs.container
            this.$copyText(this.url, container);
            alert('Copied!');
        },


    },

    directives: {
        'click-outside': {
            bind: function (el, binding, vNode) {
                // Provided expression must evaluate to a function.
                if (typeof binding.value !== 'function') {
                    const compName = vNode.context.name
                    let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
                    if (compName) {
                        warn += `Found in component '${compName}'`
                    }

                    console.warn(warn)
                }
                // Define Handler and cache it on the element
                const bubble = binding.modifiers.bubble
                const handler = (e) => {
                    if (bubble || (!el.contains(e.target) && el !== e.target)) {
                        binding.value(e)
                    }
                }
                el.__vueClickOutside__ = handler

                // add Event Listeners
                document.addEventListener('click', handler)
            },

            unbind: function (el, binding) {
                // Remove Event Listeners
                document.removeEventListener('click', el.__vueClickOutside__)
                el.__vueClickOutside__ = null

            }
        }
    }

};


</script>
<style>


.social-share-app {
    display: inline-block;
    position: relative;
}

.social-share-app .social {
    display: none;
    width: 135px;
    position: absolute;
    left: -145px;
    top: -5px;
}

.social-share-app .share-more {
    padding-right: 10px;
    cursor: pointer;
}

.social-share-app .share-more.active {
    filter: invert(27%) sepia(58%) saturate(3768%) hue-rotate(255deg) brightness(97%) contrast(98%);
}

.social-share-app .social a {
    height: 23px;
    width: 23px;
}

.social-share-app .social img {
    width: 100%;
    opacity: 0.7;
}

.social-share-app .social img:hover {
    opacity: 1;
}

.social-share-app .share-more:hover {
    filter: invert(27%) sepia(58%) saturate(3768%) hue-rotate(255deg) brightness(97%) contrast(98%);
}


@media only screen and (max-width: 991px) {
    .social-share-app {
        z-index: 4;
    }
    .social-share-app .social {
        display: none;
        width: 311px;
        height: 81px;
        left: -274px;
        top: -30px;
        box-shadow: 0px 4px 20px rgba(32, 0, 51, 0.4);
        background: rgba(32, 0, 51, 0.9);
        border-radius: 20px;
        padding-right: 48px;
    }


    .social-share-app .social a {
        width: 40px;
        height: 40px;
        margin-left: 8px;
        padding-top: 15px;
    }
    .social-share-app .social img {
        width: 100%;
        opacity: 1;
    }
    .social-share-app .share-more:hover {
        filter: initial;
    }
    .social-share-app .share-more.active {
        filter: brightness(0) invert(1);
    }

}
</style>

